import { CustomType } from "app/core/shared/shared.type";

export const jobCategoryData: CustomType[] = [
  {
    id: '1',
    label: 'Category 1',
    value: 'Category 1'
  },
  {
    id: '2',
    label: 'Category 2',
    value: 'Category 2'
  }
]
